export enum ActivitysField {
  Lead = "leadId"
}
